import { lazy } from 'react';


export const DetailCourse = lazy(() => import('./DetailCourse'));
